export const GENDER_TYPE_OPTIONS = [
  {
    value: '-',
    text: 'Unknown',
  },
  {
    value: 'F',
    text: 'Female',
  },
  {
    value: 'M',
    text: 'Male',
  },
] as const;

export type GenderType = (typeof GENDER_TYPE_OPTIONS)[number]['value'] | '';
